import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function Cannes({ event }) {
  const head = {
    title: "Cannes 2025 Event Series - Landmark Ventures",
    description:
      "Join us for our 2025 Event Series - Landmark Networking at Cannes.",
    url: "https://cannes.landmarkventures.com",
    image: "https://i.imgur.com/aIdttdH.jpeg",
  };

  return (
    <>
      <Head head={head} />
      <div className="events-wrapper cannes-wrapper redesign">
        <Intro event={event} />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request event={event} />
        {/* <Company /> */}
        {/* <Partner /> */}
      </div>
    </>
  );
}
